import { Media } from "../types/Medias"

/**
 * Extracts the best available URL from a Media object
 * 
 * This function attempts to get the most appropriate image URL from a Media object,
 * following a fallback hierarchy: direct URL → small format → medium format → large format
 * 
 * @param media - The Media object containing URL information, can be null or undefined
 * @returns The best available URL as a string, or undefined if no URL is available
 * 
 * @example
 * ```ts
 * const media = { url: "https://example.com/image.jpg" };
 * const url = getMediaUrl(media); // "https://example.com/image.jpg"
 * 
 * const mediaWithFormats = { 
 *   formats: { 
 *     small: { url: "https://example.com/small.jpg" },
 *     medium: { url: "https://example.com/medium.jpg" }
 *   }
 * };
 * const url = getMediaUrl(mediaWithFormats); // "https://example.com/small.jpg"
 * ```
 */
export function getMediaUrl(media?: Media | null) {
  if (!media) {
    return undefined
  }

  if (media.local) {
    return getMediaUrl(media.local)
  }

  return media.url || media.formats?.small?.url || media.formats?.medium?.url || media.formats?.large?.url || undefined
}
